import { render, staticRenderFns } from "./Aprovacao.vue?vue&type=template&id=55db4270&"
import script from "./Aprovacao.vue?vue&type=script&lang=js&"
export * from "./Aprovacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports